import { Component } from '@angular/core';

import { componentOutletConfigFactory } from '@core/common-legacy';

import type { DataTableRow, TableCellFactory } from '../data-table.types';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  standalone: true,
  template: `{{ value }}`,
  host: {
    '[class]': 'class',
  },
  inputs: TextCellComponent.NgInputs,
})
export class TextCellComponent {
  public static NgInputs = ['value' as const, 'class' as const];

  public value: any;
  public class: string | number;
}

export const EMPTY_CELL = componentOutletConfigFactory(TextCellComponent, {
  inputs: {
    value: '—',
    class: 'empty',
  },
});

export const textCellFactory =
  <Key extends Extract<keyof Row, string | number>, Row extends DataTableRow>(
    key: Key,
    transformFn?: (value: Row[Key]) => string | number | null | undefined,
  ): TableCellFactory<Row> =>
  ({ row }) => {
    const value = transformFn ? transformFn(row[key]) : row[key];
    if (value === undefined || value === null) return EMPTY_CELL;

    return componentOutletConfigFactory(TextCellComponent, { inputs: { value, class: key } });
  };
